module.exports = __webpack_public_path__ + "public/files/img/loading.8c4f192e.svg";